import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';

import { firstValueFrom, map } from 'rxjs';

import { ConfirmDialogComponent } from '@eiq/ui';

import { PendingChangesService } from '../services/pending-changes.service';

export const PendingChangesGuard: CanDeactivateFn<boolean> = (_component, _currentRoute, _currentState, _nextState) => {
  const pendingChangesService = inject(PendingChangesService);
  const dialog = inject(MatDialog);

  if (pendingChangesService.hasUnsavedChanges()) {
    const dialogRef = dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Unsaved Changes',
        confirmText: pendingChangesService.customText || 'You have unsaved changes. Are you sure you want to leave without saving?',
        confirmBtn: 'Stay',
        cancelBtn: 'Leave',
        color: 'primary'
      }
    });

    return firstValueFrom(
      dialogRef.afterClosed().pipe(
        map((stay) => {
          if (!stay) {
            pendingChangesService.discardChanges();
            return true;
          }
          return false;
        })
      )
    );
  }

  return true;
};
